import { useModalStore } from "@/hooks/Modal/hooks";
import { UniversalOrderSettingType } from "@/services/api/universalOrderSetting";
import { useGlobalStore } from "@/store/hooks";
import CopyOrderInfoSettingModal from "../../../dialogs/CopyOrderInfoSettingModal";
import OrderDTO from "@/dto/order/OrderDTO";
import copy from "copy-to-clipboard";
import { message } from "antd";
import {
    buildOrderInfoText,
    CopyOrderInfoOption,
    OrderInfoNameMap,
} from "../../../dialogs/CopyOrderInfoSettingModal/utils";
import { useOrderSetting } from "@/hooks/useOrderSetting";
import { collectEvent } from "@/services/dataTrack";
import DataTrackEvent from "@/services/dataTrack/enum/DataTrackEvent";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import OrderTabNameMap from "@/scenes/OrderManagement/map/OrderTabNameMap";

export function useCopyOrderInfoClick(shopId?: number, tab?: OrderTab) {
    const globalStore = useGlobalStore();
    const modalStore = useModalStore();

    const { runAsync } = useOrderSetting<CopyOrderInfoOption[]>({
        companyId: globalStore.companyId,
        type: UniversalOrderSettingType.COPY_ORDER_INFO,
        defaultValue: [],
        manual: true,
    });

    async function handleCopyOrderInfoClick(orders: OrderDTO[]) {
        const response = await runAsync();

        if (!response?.parsedData?.length) {
            modalStore.openModal(CopyOrderInfoSettingModal, { orders });
        } else {
            const text = buildOrderInfoText(orders, response.parsedData);
            if (text) {
                copy(text);
                message.success("复制成功");
            }
        }

        try {
            if (shopId) {
                const shop = globalStore.shopMapping.get(shopId);

                collectEvent(DataTrackEvent.COPY_ORDER_INFO, {
                    shop_id: shop ? shop.id : null,
                    shop_name: shop ? shop.name : null,
                    shop_type: shop ? shop.type : null,
                    companyId: shop ? null : globalStore.companyId,
                    content: response.parsedData.map(({ value }) => OrderInfoNameMap[value]).join(),
                    context: OrderTabNameMap[tab],
                });
            }
        } catch {}
    }

    return {
        handleCopyOrderInfoClick,
    };
}
